import React, { useEffect } from 'react';
import { IForm } from './EmbedClaimPortal';
import { NotificationTypes } from 'utils';

interface IPreviewProps {
  form: IForm;
  showNotification: (type: NotificationTypes, message: string) => void;
}

const Preview = ({ form }: IPreviewProps) => {
  useEffect(() => {
    const preview = document.getElementById('container');

    if (preview) {
      preview.innerHTML = '';

      // Preview Widget Container
      const widget = document.createElement('div');
      widget.id = 'widget';
      widget.style.width = '100%';
      widget.style.height = '100vh';

      preview.appendChild(widget);
      const portalWindow = window as Window & {
        initShipAidPortal?: (selector: string, options: { key: string }) => void;
      };
      const started = performance.now();
      let active = true;
      let frame: number | undefined;
      const checkLoaded = () => {
        if (!active) return;
        if (typeof portalWindow.initShipAidPortal === 'function') {
          portalWindow.initShipAidPortal('#widget', { key: typeof form.key === 'string' ? form.key : '' });
        } else if (performance.now() - started < 10000) {
          frame = requestAnimationFrame(checkLoaded);
        }
      };
      checkLoaded();
      return () => {
        active = false;
        if (frame !== undefined) cancelAnimationFrame(frame);
      };
    }
  }, [form]);

  return (
    <div className="w-full h-full">
      <div
        className="w-full h-full rounded-lg overflow-hidden bg-white"
        style={{ minHeight: '600px' }}
      >
        <div
          className="flex justify-center items-center w-full h-full"
          id="container"
          style={{ minHeight: '600px' }}
        ></div>
      </div>
    </div>
  );
};

export default Preview;
